import styled from "styled-components"

const Title = styled.h1`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const SubTitle = styled.h3`
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`
const TaxoButton = styled.span`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  background-color: white;
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & > a {
    color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
const StyledFooter = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_medium};
`

export { Title, SubTitle, TaxoButton, StyledFooter }
